import demoSession from '@/data/demo/session.json'

function assertString(value, label) {
  if (typeof value !== 'string' || !value.trim()) {
    throw new Error(`Invalid demo session: ${label} must be a non-empty string.`)
  }
}

function assertArray(value, label) {
  if (!Array.isArray(value) || value.length === 0) {
    throw new Error(`Invalid demo session: ${label} must be a non-empty array.`)
  }
}

function validateDemoSession(session) {
  if (!session || typeof session !== 'object') {
    throw new Error('Invalid demo session: root object is required.')
  }

  assertString(session.featuredWorkspaceId, 'featuredWorkspaceId')
  assertString(session.featuredJobId, 'featuredJobId')
  assertArray(session.workspaces, 'workspaces')
  assertArray(session.jobs, 'jobs')

  const workspaceIds = new Set(session.workspaces.map((workspace) => workspace.id))
  const jobIds = new Set(session.jobs.map((job) => job.id))

  if (!workspaceIds.has(session.featuredWorkspaceId)) {
    throw new Error('Invalid demo session: featuredWorkspaceId does not match a workspace.')
  }

  if (!jobIds.has(session.featuredJobId)) {
    throw new Error('Invalid demo session: featuredJobId does not match a run.')
  }
}

validateDemoSession(demoSession)

export const demoWorkspaceId = demoSession.featuredWorkspaceId
export const demoJobId = demoSession.featuredJobId
export const demoLandingPage = demoSession.landingPage
export const demoCapture = demoSession.capture
export const demoWorkspaces = demoSession.workspaces
export const demoJobs = demoSession.jobs
export const demoWorkspace = demoWorkspaces.find((workspace) => workspace.id === demoWorkspaceId) || null
export const demoJob = demoJobs.find((job) => job.id === demoJobId) || null

export function getDemoWorkspace(workspaceId) {
  return demoWorkspaces.find((workspace) => workspace.id === workspaceId) || null
}

export function getDemoJob(jobId) {
  return demoJobs.find((job) => job.id === jobId) || null
}
